import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Modal } from 'react-bootstrap';
import closePng from 'images/close.png';
import leftArrowPng from 'images/left-arrow.png';
import './FormModal.css';

class FormModal extends Component {
  static propTypes = {
    id: PropTypes.string,
    className: PropTypes.string,
    show: PropTypes.bool.isRequired,
    showHeader: PropTypes.bool,
    subTitle: PropTypes.any,
    title: PropTypes.any,
    onBack: PropTypes.func,
    onClose: PropTypes.func,
  };

  static defaultProps = {
    showHeader: true,
    onClose: () => {},
  };

  render() {
    return (
      <Modal
        id={this.props.id}
        className={
          'form-modal' +
          (this.props.className !== undefined ? ' ' + this.props.className : '')
        }
        show={this.props.show}
      >
        {this.props.showHeader && (
          <Modal.Header>
            {this.props.onBack !== undefined && (
              <span className="back-icon">
                <img
                  src={leftArrowPng}
                  alt="back"
                  onClick={this.props.onBack}
                />
              </span>
            )}
            {this.props.subTitle !== undefined && this.props.subTitle}
            <div className="h1">{this.props.title}</div>
            <span className="close-icon">
              <img src={closePng} alt="close" onClick={this.props.onClose} />
            </span>
          </Modal.Header>
        )}

        <Modal.Body>{this.props.children}</Modal.Body>
      </Modal>
    );
  }
}

export default FormModal;



// WEBPACK FOOTER //
// ./src/components/shared/modal/FormModal.js